// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var UserSession = require("../common/UserSession/UserSession.bs.js");

function FeatureGate$PropertyDetailsGate(props) {
  var children = props.children;
  var __negate = props.negate;
  var negate = __negate !== undefined ? __negate : false;
  var shouldShow = UserSession.useShouldShowPropertyDetails(props.otherAgentId);
  if (shouldShow) {
    if (negate) {
      return null;
    } else {
      return children;
    }
  } else if (negate) {
    return children;
  } else {
    return null;
  }
}

var PropertyDetailsGate = {
  make: FeatureGate$PropertyDetailsGate
};

var propertyDetailsGateJs = FeatureGate$PropertyDetailsGate;

exports.PropertyDetailsGate = PropertyDetailsGate;
exports.propertyDetailsGateJs = propertyDetailsGateJs;
/* UserSession Not a pure module */
